import { createFileRoute } from "@tanstack/react-router";
import { InvoiceIssuerCard } from "@/components/admin/InvoiceIssuerCard";
import { useAuth } from "@/hooks/useAuth";

export const Route = createFileRoute("/admin/vacanty")({ component: VacantyAdminPage });

function VacantyAdminPage() {
  const { hasRole, loading } = useAuth();
  const canAccess = hasRole("admin") || hasRole("vacanty_admin");

  if (loading) {
    return <div className="text-sm text-muted-foreground">Načítám…</div>;
  }
  if (!canAccess) {
    return (
      <div className="max-w-md">
        <h1 className="font-serif text-2xl">Nemáte přístup</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Tato sekce je dostupná pouze pro administrátory Vacantů a hlavního admina systému.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6 max-w-5xl">
      <div>
        <h1 className="font-serif text-3xl">Vacanty — fakturace a platby</h1>
        <p className="text-sm text-muted-foreground">
          Samostatné nastavení dodavatele faktur a platebních údajů pro objednávky <strong>Vacantů</strong>.
          Faktury pro Vacanty mají vlastní číselnou řadu, vlastního dodavatele i samostatný Stripe a WISE účet —
          nezávislé na fakturaci za reklamní služby v sekci <em>Ceník</em>.
        </p>
      </div>

      <InvoiceIssuerCard
        settingsKey="vacanty_invoice_issuer"
        title="Dodavatel faktur — Vacanty"
        description="Identifikační údaje subjektu, který vystavuje faktury za objednané Vacanty. Použije se jako dodavatel na fakturách s vlastní číselnou řadou."
        invoicePrefixHint="Doporučeno samostatné prefixování, např. VAK-2026- pro odlišení od ceníkových faktur."
      />
    </div>
  );
}
